<script>
import UploadCsv from './UploadCsv.vue';

export default {
   name: 'ScheduledReportsToEmail',
    data() {
        return {
            showUploadComponent: false,
            email: '',
            emailIds: this.prefillEmailIds?.length > 0 ? this.prefillEmailIds : [],
            search: '',
            emptyMessage: 'Enter email id for schedule',

        }
    },
    components: {
        UploadCsv,
    },
    props:{
        prefillEmailIds: Array
    },
    computed: {
        resultQuery(){
            if(this.search){
                return this.emailIds.filter((item)=>{
                    return item.toLowerCase().includes(this.search.toLowerCase())
                })
            }
        }
    },
    methods: {
        onUploadClick () {
          this.showUploadComponent = true
        },
        onListClick () {
          this.showUploadComponent = false
          this.emptyMessage = 'Enter email id for schedule'
        },
        onUploadBtnclick(){
          this.showUploadComponent = false
        },
        isValidEmail(email) {
            const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
            return emailPattern.test(email);
        },
        addEmail() {
            if(this.isValidEmail(this.email)){
                this.emailIds.push(this.email);
                this.$emit('emailIds', this.emailIds)
            }
            this.email='';
        },
        getEmailIDArray(value){
            this.emailIds=value
            this.$emit('emailIds', this.emailIds)
        },
        onRemoveAllClick(){
            this.emailIds = [];
            this.$emit('emailIds', this.emailIds)
        }
    },
}
</script>

<template>
    <div class="scheduledReportsToEmail">
        <div class="title">Email id</div>
        <div class="table"> 
            <div class="firstRow"> 
                <div v-bind:class="{'activeClass': !showUploadComponent}"  @click="onListClick" class="row">Enter list</div>
                <div v-bind:class="{'activeClass': showUploadComponent}" @click="onUploadClick" class="row">Upload</div>
            </div>
            <div v-if="(!showUploadComponent)">
                <div class="secondRow"> 
                    <div class="search" style="width: 100%"> 
                        <img alt="img" class="searchIcon" src="../assets/SearchIcon.svg"/>
                        <input :disabled="this.isDisabled" class="searchClass" v-model="search" type="text" style="width: 100%; padding-left: 30px;" v-bind:placeholder="`search added emails`">
                        <div class="searchText"></div>
                    </div>
                </div>
                <div class="list"> 
                    <div class="thirdRow"> 
                        <div class="text">Email ID</div>
                        <div class="text remove" @click="onRemoveAllClick">Remove all</div>
                    </div>

                    <div class="search"> 
                        <input class="searchClass" v-model="email" type="text" placeholder="Type email id here">
                        <div class="searchBtn" @click="addEmail">Add</div>
                        <div class="searchText"></div>
                    </div>

                    <div class="emptyCase" v-if="emailIds?.length===0 ">
                        <img alt="img" src="../assets/emptyCase.svg">
                        <div class="emptyText">{{ this.emptyMessage }}</div>
                    </div>
                    <div class="rowWrapper" v-else> 
                        <div v-if="resultQuery"> 
                            <div v-for="(item) in resultQuery" :key="item">
                                <div class="rows">{{ item }}</div>
                            </div>
                        </div>
                        <div v-else v-for="(item) in emailIds" :key="item">
                            <div class="rows">{{ item }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else> 
                <UploadCsv uploadCsvType="emails" @emailIDArray="getEmailIDArray" @uploadBtnclicked="onUploadBtnclick"></UploadCsv>
            </div>
        </div>
    </div>    
</template>


<style scoped>

    @font-face {
        font-family: "Inter-Regular";
        src: url('../assets/fonts/Inter-Regular.ttf');
    }
    .scheduledReportsToEmail{
        padding: 0 0 44px 24px;
        min-height: 364px;
        max-height: 364px;
        margin-bottom: 40px;
    }

    .title{
        font-family: "Inter-Regular";
        font-size: 12px;
        font-weight: 600;
        line-height: 15px;
        letter-spacing: 0em;
        text-align: left;
        margin-bottom: 10px;
        color: #333333;
    }

    
    .table{
        border: 1px solid #E0E0E0;
        border-radius: 12px;
        max-width: 350px;
        min-width: 350px;
    }

    .firstRow{
        display: flex;
        border-bottom: 1px solid #E0E0E0;
        padding: 14px 0 0 22px;
        background: #F8F8F8;
    }

    .secondRow{
        display: flex;
        background: #F8F8F8;
    }

    .thirdRow{
        background: #EFEFEF;
        padding: 2px 22px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .text{
        font-weight: 500;
        font-size: 12px;
        line-height: 21px;
        letter-spacing: 0em;
        color: #333333;
    }

    .remove{
        color: #BF0B0B;
        cursor: pointer;
    }

    .search{
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 18px 18px 14px 16px;
    }

    .searchIcon{
        position: absolute;
        left: 26px;
    }

    .searchBtn{
        color: #FFFFFF;
        background: #2E31BE;
        border-radius: 4px;
        padding: 8px 22px;
        cursor: pointer;
        font-size: 12px;
        font-weight: 700;
        line-height: 18px;
        letter-spacing: 0em;
        text-align: center;
        margin-left: 16px;
    }

    .searchClass{
        /* margin-right: 16px; */
        background: #FFFFFF;
        border: 1px solid #E4E5E6;
        border-radius: 4px;
        width: 218px;
        padding: 6px 0px 6px 14px;
        font-family: "Inter-Regular";
        font-size: 12px;
        font-weight: 400;
        line-height: 26px;
        letter-spacing: 0px;
        text-align: left;
    }

    .searchText{
        font-weight: 400;
        font-size: 12px;
        line-height: 26px;
        display: flex;
        background: #FFFFFF;
        border: unset;
    }

    .row{
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
        color: #666666;
        margin-right: 38px;
        cursor: pointer;
        padding-bottom: 8px;
    }

    .activeClass{
        border-bottom: 3px solid #2E31BE;
    }

    .emptyText{
        font-family: "Inter-Regular";
        font-size: 12px;
        font-weight: 400;
        line-height: 21px;
        letter-spacing: 0em;
        text-align: left;
        color: #4D4D4E;
    }

    .emptyCase{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 10px 0 40px;
    }
    .productWrapper{
        display: flex;
        justify-content: space-between;
        border: 1px solid #C4C4C4;
        border-radius: 8px;
        padding: 16px 13px;
        margin-bottom: 8px;
        background: #FFFFFF;
    }

    .productDetailsWrapper{
        display: flex;
    }
    .rowWrapper{
        height: 178px;
        overflow-y: scroll;
    }
    .rows{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 30px 0px 42px;
        border-bottom: 0.8px solid #D9D9D9;
        height: 40px;
        font-weight: 400;
        font-size: 12px;
        line-height: 21px;
        color: #000000;
    }
</style>
